import { Box, Typography } from "@mui/material";
import ParseHTML from "./ParseHTML";

//This function renders a custom or general error text.
export default function AccessDeniedText() {

    let text: string = process.env.REACT_APP_GENERAL_ACCESS_DENIED_TEXT!;
    
    return (
        <Box padding={2}>
            <Typography variant="h6" color="secondary.dark" paragraph={true}>{ParseHTML(text)}</Typography>
        </Box>
    );
}